<template>
	<div>
		<div class="content" v-loading.fullscreen.lock="loading">
			<div class="content-c">
				<div class="main">
					<span>该数据统计为了后期检查人员能够更快的联系上填报人员进行业务沟通。</span>

					<div class="option">
						<div class="prefix">填报人员姓名:</div>
						<div class="item">
							<el-input placeholder="姓名" v-model="information.name"></el-input>
						</div>
					</div>
					<div class="option">
						<div class="prefix">QQ:</div>
						<div class="item">
							<el-input placeholder="QQ" v-model="information.qq"></el-input>
						</div>
					</div>
					<div class="option">
						<div class="prefix">联系电话:</div>
						<div class="item">
							<el-input placeholder="联系电话" v-model="information.phone"></el-input>
						</div>
					</div>
					<div class="option">
						<div class="prefix">邮箱:</div>
						<div class="item">
							<el-input placeholder="邮箱" v-model="information.email"></el-input>
						</div>
					</div>
					<div class="button">
						<el-button @click="save">保存</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { user, userEdit } from "@/api/user.js";
	export default {
		data() {
			return {
				loading: false,
				information: {},
			};
		},
		created() {
			this.init();
		},
		mounted() { },
		methods: {
			// 保存
			save() {
				let re = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
				this.loading = true;
				if (this.information.name == '') {
					this.information.name = null
				}
				if (this.information.qq == '') {
					this.information.qq = null
				}
				if (this.information.phone == '') {
					this.information.phone = null
				}
				if (this.information.email == '') {
					this.information.email = null
				} else if(!re.test(this.information.email) && this.information.email){
					this.$message.error("邮箱格式错误");
					this.loading = false;
					return
				}
				userEdit(this.information)
					.then((res) => {
						if (res.status == 0) {
							this.$message.success("已保存");
							this.getUser();
							this.show = false;
						}
						this.loading = false;
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			init() {
				this.loading = true;
				user().then((res) => {
					if (res.status == 0) {
						this.information.id = res.id;
						this.information.name = res.name;
						this.information.qq = res.qq;
						this.information.phone = res.phone;
						this.information.email = res.email;
					}
					this.loading = false;
					// console.log(this.information)
				}).catch(err => {
					this.loading = false;
				})
			},
		},
	};
</script>

<style scoped>
	.content {
		height: 500px;
		width: 80%;
		margin: 0 auto;
		margin-top: 100px;
	}

		.content .content-c {
			display: flex;
			justify-content: center;
			align-items: center;
		}

			.content .content-c .main {
				height: 400px;
				width: 50%;
			}

				.content .content-c .main .option {
					height: 80px;
					margin: 10px 0;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: 55px !important;
					font-size: 20px !important;
					font-weight: 500 !important;
					font-family: fangsong !important;
				}

					.content .content-c .main .option .prefix {
						width: 35%;
					}

					.content .content-c .main .option .item {
						width: 60%;
						margin-left: 40px;
					}

	.button {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>